import { DesignedModal, Button } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import React, { Dispatch, SetStateAction } from 'react'

export const ConfirmationModal = ({
  setIsOpen,
  onApprove,
}: {
  setIsOpen: Dispatch<SetStateAction<boolean>>
  onApprove: () => void
}) => {
  const { t } = useTranslation('domainManagement')

  const translate = (key: string, options?: Record<string, string>): string =>
    t(`add_new_multiple_domains_modal.confirmation_modal.${key}`, options)

  return (
    <DesignedModal
      isOpen
      text={translate('text')}
      onOpenChange={setIsOpen}
      actions={
        <>
          <Button variant="outline" text={translate('no')} onClick={() => setIsOpen(false)} />
          <Button text={translate('yes')} onClick={onApprove} />
        </>
      }
    />
  )
}
